import CompanyQuoteBlueSky from './CompanyQuoteBlueSky'

export { CompanyQuoteBlueSky }
export default CompanyQuoteBlueSky
